import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_site-builder-3580/artifacts/8f1fzcms_image.png";

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    setOpen(false);
  }, [location.pathname, setOpen]);

  const links = [
    { to: "/", label: "Home" },
    { to: "/womens", label: "Women's Haven" },
    { to: "/mens", label: "Men's Haven" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-md bg-[rgba(26,10,46,0.78)] border-b border-[rgba(212,175,55,0.18)]"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 flex items-center justify-between h-20">
        <Link to="/" data-testid="navbar-logo-link" className="flex items-center gap-3">
          <div className="relative h-16 w-16 rounded-full bg-[#f7f2e7] flex items-center justify-center shadow-[0_0_24px_-6px_rgba(212,175,55,0.45)] ring-1 ring-[rgba(212,175,55,0.45)] overflow-hidden">
            <img
              src={LOGO_URL}
              alt="Beds of Haven"
              className="h-[88%] w-[88%] object-contain"
            />
          </div>
          <div className="leading-tight hidden sm:block">
            <div className="font-serif text-xl text-[#f0d479]">Beds of Haven</div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#b395d6]">
              A Safe Place · A Fresh Start
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={`text-sm tracking-wide transition-colors ${
                location.pathname === l.to
                  ? "text-[#f0d479]"
                  : "text-[#e8dcc0] hover:text-[#f0d479]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/apply"
            data-testid="navbar-apply-btn"
            className="btn-gold text-sm"
          >
            Apply Now
          </Link>
        </nav>

        <div className="lg:hidden flex items-center gap-3">
          <a
            href="tel:7064318996"
            data-testid="navbar-call-mobile"
            className="text-[#f0d479]"
            aria-label="Call"
          >
            <Phone size={20} />
          </a>
          <button
            data-testid="navbar-menu-toggle"
            onClick={() => setOpen(!open)}
            className="text-[#f0d479]"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="lg:hidden border-t border-[rgba(212,175,55,0.18)] bg-[#1a0a2e]"
        >
          <div className="px-5 py-5 flex flex-col gap-4">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="text-[#e8dcc0] hover:text-[#f0d479] py-1"
              >
                {l.label}
              </Link>
            ))}
            <Link to="/apply" data-testid="mobile-apply-btn" className="btn-gold w-fit">
              Apply Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
